import { FC, HTMLAttributes } from 'react';

type LeapWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const LeapWallet: FC<LeapWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 166 166"
      {...props}
    >
      <g clipPath="url(#leapwallet_clippath_a)">
        <path fill="#C5FFCE" d="M0 0h166v166H0z"></path>
        <path
          fill="#24A95A"
          d="M138.614 100.445c0 19.772-24.131 27.807-54.092 27.807-29.962 0-54.444-8.035-54.444-27.807 0-19.773 24.307-35.772 54.268-35.772s54.268 16.034 54.268 35.772"
        ></path>
        <path
          fill="#32DA6D"
          d="M133.103 57.347c0-10.41-8.5-18.864-18.967-18.864a18.98 18.98 0 0 0-13.806 5.934c-.536.565-1.318.84-2.081.686a69.8 69.8 0 0 0-13.793-1.38c-4.78 0-9.413.466-13.793 1.372-.763.158-1.55-.113-2.088-.676-3.485-3.646-8.388-5.936-13.8-5.936-10.467 0-18.967 8.454-18.967 18.864 0 3.036.718 5.88 1.983 8.41.303.606.334 1.315.072 1.94-1.228 2.924-1.88 6.012-1.88 9.213 0 18.34 21.708 33.186 48.473 33.186s48.472-14.846 48.472-33.186c0-3.2-.652-6.289-1.88-9.213a2.33 2.33 0 0 1 .072-1.94 18.7 18.7 0 0 0 1.983-8.41"
        ></path>
        <path
          fill="#fff"
          d="M53.227 67.812c6.402 0 11.591-5.161 11.591-11.528s-5.19-11.528-11.59-11.528c-6.403 0-11.592 5.161-11.592 11.528s5.19 11.528 11.591 11.528M115.065 67.812c6.401 0 11.591-5.161 11.591-11.528s-5.19-11.528-11.591-11.528c-6.402 0-11.591 5.161-11.591 11.528s5.189 11.528 11.591 11.528"
        ></path>
        <path
          fill="#32DA6D"
          d="M47.076 126.829c2.494 0 4.46-2.166 4.18-4.611-1.019-8.664-5.34-27.423-24.342-38.707-20.83-12.372-10.92 20.523-6.777 32.508.837 2.424-.134 5.116-2.359 6.392l-1.366.785c-1.756 1.013-1.018 3.633.984 3.633zM122.566 126.829c-2.248 0-4.004-2.166-3.758-4.611.878-8.629 4.812-27.423 21.953-38.707 18.98-12.468 9.742 21.036 6.054 32.783-.723 2.304.167 4.812 2.207 6.105l1.258.797c1.58 1.013.913 3.633-.878 3.633z"
        ></path>
        <path
          fill="#092511"
          d="M53.243 63.179a6.915 6.915 0 1 0 0-13.83 6.915 6.915 0 0 0 0 13.83M115.081 63.179a6.914 6.914 0 0 0 6.914-6.915 6.914 6.914 0 1 0-13.829 0 6.915 6.915 0 0 0 6.915 6.915M99.8 83.018c1.714.147 3.01 1.668 2.578 3.334a18.571 18.571 0 0 1-36.542-4.176c-.03-1.147.988-1.995 2.131-1.897l16.434 1.414z"
        ></path>
      </g>
      <defs>
        <clipPath id="leapwallet_clippath_a">
          <path fill="#fff" d="M0 0h166v166H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default LeapWallet;
